
import Vue from "vue";
import {ISelectItem} from "winfakt-vue-components/src/classes";
import {CompanyStatsFilter} from "@/utils/company-stats-filter";

export enum Mode {
	DAYS7 = 13,
	DAYS14 = 14,
	MONTHS3 = 15,
	UNTILNOW = 16,
}
export default Vue.extend({
	data() {
		return {
			year: new Date().getFullYear(),
			mode: Mode.DAYS7,
			result: [] as number[]
		};
	},
	props: {
		filter: Object as () => CompanyStatsFilter
	},
	computed: {
		modeSelectItems(): ISelectItem<Mode>[] {

			let a = [] as ISelectItem<any>[];

			Array.from({length: 12}, (item, i) => {
				a.push({text: new Date(0, i).toLocaleString("nl-NL", {month: "long"}).toString(), value: i+1});
			});

			let e = [
				{
					text: "Januari tot nu",
					value: Mode.UNTILNOW
				}/*,
				{
					text: "Laatste 14 dagen",
					value: Mode.DAYS14
				},
				{
					text: "Laatste 3 maanden",
					value: Mode.MONTHS3
				}*/
			];
			a = a.concat(e);

			return a as ISelectItem<Mode>[];
		},
		yearSelectItems(): ISelectItem<Mode>[] {

			let y = new Date().getFullYear();
			let a = [];

			for (let i = 2020; i <= y; i++) {
				a.push({text: i.toString(), value: i});
			}
			return a as ISelectItem<Mode>[];
		}

	},
	methods: {
		setYear(e:number) {
			this.year = e;
			this.$emit("filter", {year: this.year, mode: this.mode});
		},
		setMode(e:number) {
			this.mode=e;
			this.$emit("filter", {year: this.year, mode: this.mode});
		}
	},
	created() {
		this.year = this.filter.year;
		this.mode = this.filter.mode;
	}
});
